<template>
    <span :class="{'text':true,'show-blank':isShowBlank}">
        <span>{{ this.data }}</span>
    </span>
</template>

<script>
  export default {
    props: [
      'data'
    ],
    computed: {
      isShowBlank(){
        return /^\s+[\S]+/.test(this.data)
      }
    }
  }
</script>
<style>
  .show-blank{
    white-space:pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/common/text.vue